import dayjs from 'dayjs';
import { AnalyticsGatewayV1 } from '@frontend/api-analytics-gateway';
import { demoDataUtils } from '../../../../utils';

const allLocationsTrend = [46, 50, 48, 30, 55, 60];
const yourLocationTrend = [50, 55, 52, 35, 60, 65];
const newPatientsTrend = [60, 65, 62, 40, 70, 75];
const existingPatientsTrend = [40, 45, 42, 25, 50, 55];

const averageDifference = (arr1: number[], arr2: number[]) => {
  if (arr1.length !== arr2.length || arr1.length === 0) {
    return 0;
  }

  let sumOfDifferences = 0;
  for (let i = 0; i < arr1.length; i++) {
    sumOfDifferences += arr2[i] - arr1[i];
  }

  return sumOfDifferences / arr1.length;
};

const calculateAverage = (arr: number[]) => {
  if (!arr || arr.length === 0) {
    return 0;
  }

  const sum = arr.reduce((acc, currentValue) => acc + currentValue, 0);
  return sum / arr.length;
};

const last6Months = Array.from({ length: 6 }, (_, i) => i)
  .map((i) => {
    return dayjs()
      .subtract(i + 1, 'month')
      .format('MMM');
  })
  .reverse();

export const generateNSRTimelineDemoData = (): AnalyticsGatewayV1.Types.GetNoShowRateIO['output'] => {
  return {
    data: {
      aggregates: [
        { name: 'Follow Up Appt', value: calculateAverage(existingPatientsTrend) },
        { name: 'New Appt', value: calculateAverage(newPatientsTrend) },
      ],
      dates: last6Months.map((month, index) => {
        return {
          key: month,
          params: [
            {
              name: 'AllLocations',
              value: allLocationsTrend[index],
            },
            {
              name: 'SelectedLocations',
              value: yourLocationTrend[index],
            },
            {
              name: 'New Appt',
              value: newPatientsTrend[index],
            },
            {
              name: 'Follow Up Appt',
              value: existingPatientsTrend[index],
            },
          ],
        };
      }),
      previousDateRangeDifference: 2,
      rateDifference: averageDifference(allLocationsTrend, yourLocationTrend),
    },
    message: '',
  };
};

export const generateNoShowRateAggregatesDemoData = (
  locationIds?: string[]
): AnalyticsGatewayV1.Types.GetNoShowRateAggregatesIO['output'] => {
  return {
    data: {
      locations: (locationIds || []).map((locationId) => ({
        aggregates: [
          {
            name: 'Follow Up Appt',
            value: demoDataUtils.generateRandomInt(30, 50),
          },
          {
            name: 'New Appt',
            value: demoDataUtils.generateRandomInt(40, 60),
          },
        ],
        locationId,
        noShowRate: demoDataUtils.generateRandomInt(10, 20),
      })),
      unsubscribed: 0.2,
    },
    message: '',
  };
};
